import Impact from './Impact';

class Action {
  constructor(description, risk, category, rationale, icon_filename, c_cost, p_cost, q_cost, impacts) {
    this.description = description;
    this.risk = risk;
    this.category = category;
    this.rationale = rationale;
    this.iconFilename = icon_filename;
    this.cost = new Impact(c_cost, p_cost, q_cost);
    this.impacts = [];
    for (var i = 0; (i*4) < impacts.length; i++) {
      let baseIndex = i * 4;
      this.impacts[i] = new Impact(impacts[baseIndex], impacts[baseIndex+1], impacts[baseIndex+2], impacts[baseIndex+3]);
    }
  }

  validate(row) {
    var errors = [];
    if (!this.description || this.description.length === 0) errors.push(`Action description is empty in row ${row}`);
    if (!this.risk || this.risk.length === 0) errors.push(`Action risk is empty in row ${row}`);
    if (!this.category || this.category.length === 0) errors.push(`Action category is empty in row ${row}`);
    if (!this.rationale || this.rationale.length === 0) errors.push(`Action rationale is empty in row ${row}`);
    if (!this.iconFilename || this.iconFilename.length === 0) {
      errors.push(`Action icon filename is empty in row ${row}`);
    } else {
      if (![".png", ".jpg"].includes(this.iconFilename.slice(-4))) errors.push(`Action icon filename is not a png or jpg in row ${row}`);
    }
    if (this.cost.c > 0) errors.push(`Action has positive cost in row ${row}`);
    if (this.cost.p < 0) errors.push(`Action has negative preparedness in row ${row}`);
    if (this.cost.q < 0) errors.push(`Action has positive quality of life in row ${row}`);

    this.impacts.forEach((impact, i) => { 
      if (impact.c < 0) errors.push(`Action has negative cost impact in row ${row}, event ${i+1}`);
      if (impact.p < 0) errors.push(`Action has negative preparedness impact in row ${row}, event ${i+1}`);
      if (impact.q < 0) errors.push(`Action has negative quality of life impact in row ${row}, event ${i+1}`);
    });
    return errors;
  }
}

export default Action;



// WEBPACK FOOTER //
// ./src/models/Action.js